/**
 * AR pago-con-factura warning. The receptor fiscal fields (condición IVA /
 * CUIT) are captured by the vendedor on the contacto; if they're missing,
 * Facturación can't emit the CAE later and whoever approves facturas can't fix
 * it. So we flag it here — at the point a vendor uploads a pago/promesa con
 * factura, where it can actually be corrected. Shown in every upload dialog
 * (RegistrarPago / SubirComprobante / EditarPago) when "Lleva Factura" is on.
 *
 * Renders nothing when `missing` is empty/null — callers still gate on the
 * "Lleva Factura" toggle so the warning only shows when a factura is intended.
 */
export function FiscalDataMissingWarning({
  missing,
}: {
  missing: string[] | null | undefined;
}) {
  if (!missing || missing.length === 0) return null;
  return (
    <div className="rounded-xl border border-amber-300 bg-amber-50 px-3 py-2 text-xs text-amber-900">
      <p className="font-medium">Faltan datos fiscales del cliente</p>
      <p className="mt-0.5 leading-snug">
        Para guardar este cobro con factura, completá primero en el cliente:{' '}
        <strong>{missing.join(', ')}</strong>. Sin estos datos, Facturación no
        podría emitir el comprobante.
      </p>
    </div>
  );
}
